var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('NoticeChannel'),_c('RedDotChannel'),_c('AsyncDataChannel')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }